/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=7e1915e9&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=7e1915e9&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e1915e9"]])

export default __exports__